module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Final_Step_angle_bracket.ef4dd8c5.mp4";